import { FlattenStrapiAttributes, GreetingModel } from '../../../types/app';
import { OtherCountries } from '../../../types/generated/components';

export type CountriesModel = FlattenStrapiAttributes<OtherCountries['attributes']>;
export type CompanyTypes = GreetingModel['type'];

export enum ConnectionStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  CONNECTING = 'CONNECTING',
  RECONNECTING = 'RECONNECTING',
  ERROR = 'ERROR',
}
